const ArrowDividerIcon: React.FunctionComponent = () => {
  return (
    <svg
      width="5"
      height="10"
      viewBox="0 0 5 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.206184 0.207687C0.140851 0.274081 0.0889952 0.353073 0.0536073 0.440105C0.0182193 0.527138 0 0.620488 0 0.714771C0 0.809055 0.0182193 0.902406 0.0536073 0.989438C0.0889952 1.07647 0.140851 1.15546 0.206184 1.22186L3.39864 4.49292C3.46397 4.55931 3.51583 4.6383 3.55122 4.72533C3.58661 4.81237 3.60483 4.90572 3.60483 5C3.60483 5.09428 3.58661 5.18763 3.55122 5.27467C3.51583 5.3617 3.46397 5.44069 3.39864 5.50709L0.206184 8.77814C0.140851 8.84454 0.0889952 8.92353 0.0536073 9.01056C0.0182193 9.0976 0 9.19095 0 9.28523C0 9.37951 0.0182193 9.47286 0.0536073 9.5599C0.0889952 9.64693 0.140851 9.72592 0.206184 9.79231C0.336784 9.92534 0.513451 10 0.697599 10C0.881748 10 1.05841 9.92534 1.18901 9.79231L4.38844 6.51411C4.78004 6.11237 5 5.5678 5 5C5 4.43221 4.78004 3.88763 4.38844 3.48589L1.18901 0.207687C1.05841 0.074666 0.881748 0 0.697599 0C0.513451 0 0.336784 0.074666 0.206184 0.207687Z"
        fill="#1A1E3D"
      />
    </svg>
  )
}
export default ArrowDividerIcon
